import { Point } from 'paper'

export const shapesLayout5 = [
  {
    shape: 'golf_club',
    position: new Point(90, 5.5),
    scale: 1.2,
    rotate: -81,
    color: 'purple',
    overlay: {
      shape: 'overlay',
      translate: new Point(-30, -80)
    }
  },
  {
    shape: 'droplet',
    position: new Point(2, 8),
    scale: 1.2,
    rotate: 139,
    color: 'yellow',
    overlay: {
      shape: 'overlay',
      rotate: '45',
      translate: new Point(0, 0)
    }
  },
  {
    shape: 'leaf',
    position: new Point(95, 37),
    color: 'green',
    rotate: -73,
    scale: 1,
    overlay: {
      shape: 'overlay',
      translate: new Point(120, 140),
      scale: 1.2
    }
  },
  {
    shape: 'blobby',
    position: new Point(4, 45),
    color: 'greenGif',
    scale: 1.8,
    overlay: {
      shape: 'overlay',
      translate: new Point(140, -170),
      scale: 1.2
    }
  },
  {
    shape: 'droplet',
    position: new Point(4, 50),
    color: 'blueDark',
    scale: 1,
    rotate: 120
  },
  {
    inset: 'cardamom',
    position: new Point(92, 48),
    scale: 0.7,
    rotate: 20
  },
  {
    inset: 'basil',
    position: new Point(95, 68),
    scale: 0.8,
    rotate: 50
  },
  {
    shape: 'tilde',
    position: new Point(82, 57),
    color: 'purple',
    rotate: -31,
    scale: 0.5
  },
  {
    shape: 'droplet',
    position: new Point(95, 86),
    color: 'skinTone',
    scale: 2.2,
    flipY: true,
    rotate: 70,
    overlay: {
      shape: 'overlay',
      translate: new Point(-40, -200),
      scale: 1
    }
  },
  {
    inset: 'star-anise',
    position: new Point(8, 99),
    scale: 0.5,
    rotate: 0
  }
]
